import { render } from "./Ia.vue?vue&type=template&id=7de985bb&scoped=true"
import script from "./Ia.vue?vue&type=script&lang=js"
export * from "./Ia.vue?vue&type=script&lang=js"

import "./Ia.vue?vue&type=style&index=0&id=7de985bb&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de985bb"]])

export default __exports__